<template>
  <div class="site-footer">
    <div class="container">
      <div class="footer-service">
        <ul class="list-service clearfix">
          <li v-for="(item, index) in site_footer.home_service" :key="index">
            <a rel="nofollow" :href="item.link" target="_blank"><img :src="item.image" />{{ item.name }}</a>
          </li>
        </ul>
      </div>
      <div class="footer-links clearfix">
        <dl class="col-links col-links-first" v-for="(item, index) in site_footer.links" :key="index">
          <dt>{{ item.name }}</dt>
          <dd v-for="(child, index) in item.list" :key="index">
            <a rel="nofollow" :href="child.link" target="_blank">{{
              child.name
            }}</a>
          </dd>
        </dl>
        <div class="col-contact">
          <p class="phone">{{ site_footer.contact.phone }}</p>
          <p>{{ site_footer.contact.work_time }}</p>
          <a rel="nofollow" class="btn btn-line-primary btn-small J_contactBtn"
            :href="site_footer.contact.customer_service_link">
            <p>
              <em class="iconfont-message2"></em>
              人工客服
            </p>
          </a>

          <div class="follow">
            关注平台：<a :href="site_footer.contact.weibo_link" target="_blank">微博</a><a
              :href="site_footer.contact.wechat_link">微信</a>
          </div>
        </div>
      </div>
      <div style="text-align:center;margin-bottom:30px;">
        <a target="_blank" href="https://beian.miit.gov.cn/">备案号：鲁ICP备2023029093号</a>
      </div>
    </div>
  </div>
</template>
<script>
import { api, session } from "@/assets/js/util.js";
export default {
  name: "SiteFooter",
  data() {
    return {
      site_footer: {
        contact: {
          phone: "",
          work_time: "",
          customer_service_link: "",
          weibo_link: "",
          wechat_link: "",
        },
      },
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      let that = this;
      let site_footer = session.get("site_footer");
      if (!site_footer === true) {
        api.get("site_footer").then(function (res) {
          if (res.code) {
            session.set("site_footer", res.data);
            that.site_footer = session.get("site_footer");
          }
        });
      } else {
        that.site_footer = session.get("site_footer");
      }
    },
  },
};
</script>
<style scoped></style>
